import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { SavedJobsStore } from './saved-jobs.store';

const SavedJobsContext = React.createContext<SavedJobsStore | null>(null);

export const SavedJobsProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<SavedJobsStore>(() => new SavedJobsStore(navigate));

   return <SavedJobsContext.Provider value={store}>{children}</SavedJobsContext.Provider>;
};

export const useSavedJobs = () => {
   const ctx = React.useContext(SavedJobsContext);
   if (!ctx) {
      throw new Error('useSavedJobs must be used inside SavedJobsProvider');
   }

   return ctx;
};
